import script from "./AppIdenticon.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppIdenticon.vue?vue&type=script&setup=true&lang=ts"

import "./AppIdenticon.vue?vue&type=style&index=0&id=f3ba9d48&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3ba9d48"]])

export default __exports__